export enum MetricCatalogView {
    LIST = 'list',
    CANVAS = 'canvas',
}

export enum SavedTreeEditMode {
    VIEW = 'view',
    EDIT = 'edit',
}
